import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-658b2632"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = {
  key: 1,
  id: "navigation-modal",
  class: "modal"
}
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  alt: "close",
  src: _imports_0
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "module-name-menu-container" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "group-item-menu" }
const _hoisted_11 = { class: "pageGroupTitle-menu" }
const _hoisted_12 = { class: "group-title-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showNavigationModal)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.showNavigationModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showNavigationModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("NAVIGATION_MODAL.TITLE")), 1),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                  }, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["module-name-menu-wrapper", { 'visible': group.click }]),
                      key: group.number
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "module-name-menu",
                          onClick: ($event: any) => {_ctx.resetHeaderZIndex(); _ctx.$emit('navigateToGroup', group)}
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getPageGroupTitle(group, _ctx.language)), 1)
                            ])
                          ])
                        ], 8, _hoisted_9)
                      ])
                    ], 2))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}